import { NgModule } from "@angular/core";
import { NoDblClickDirective } from "./no-dbl-click.directive";

@NgModule({
    declarations: [NoDblClickDirective],
    exports: [NoDblClickDirective]
})
export class NoDblClickDirectiveModule {}